import { Component, Input, input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { changeLanguage, logout } from 'src/app/root-store/actions';
import { selectBlogEnabled, selectBlogPortalUrl, selectFavoriteAnnouncementsCount } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';
import { User } from 'src/app/user/shared/models/user-model';

@Component({
    selector: 'app-header-jobseeker',
    templateUrl: './header-jobseeker.component.html',
    styleUrls: ['./header-jobseeker.component.scss'],
    standalone: false
})
export class HeaderJobseekerComponent implements OnInit {

  @Input() isSignedIn: boolean;
  @Input() user: User;
  @Input() currentLanguage: string;
  @Input() languages: string[] = [];
  @Input() providerWebsiteId: number;
  showAppsLauncher = input(true);
  favoritesIcon = input('assets/icons/header-2-heart.svg');

  isBurgerMenuOpen = false;
  isAccountMenuOpen = false;

  // 3x3 dot grid of the apps launcher, rendered purely from css
  readonly appsLauncherDots = Array(9);

  favCount$: Observable<number>;

  blogUrl$: Observable<string>;
  blogEnabled$: Observable<boolean>;

  public isActive(url: string){
    return this.router.isActive(url, { paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored'});
  }

  constructor(private store: Store<AppState>, private router: Router) { }

  ngOnInit(): void {
    this.favCount$ = this.store.pipe(select(selectFavoriteAnnouncementsCount));
    this.blogUrl$ = this.store.select(selectBlogPortalUrl);
    this.blogEnabled$ = this.store.select(selectBlogEnabled);
  }

  get initials(): string {
    return this.user?.name.trim()?.charAt(0) ?? ''
  }

  closeAllMenus(){
    this.isBurgerMenuOpen = false;
    this.isAccountMenuOpen = false;
  }

  toggleBurgerMenu() {
    this.isBurgerMenuOpen = !this.isBurgerMenuOpen;
    this.isAccountMenuOpen = false;
  }

  toggleAccountMenu() {
    this.isAccountMenuOpen = !this.isAccountMenuOpen;
  }

  selectLanguage(language: string) {
    if (language === this.currentLanguage) {
      return;
    }

    this.store.dispatch(changeLanguage({ payload: { languageId: language }}));
  }

  // TODO: the apps launcher (3x3 dot grid) has no target defined in the design yet.
  onAppsLauncherClick() {
    // TODO: implement once the apps launcher content is specified.
  }

  onSignOutClick() {
    this.closeAllMenus();
    this.store.dispatch(logout());
  }
}
